import { Action } from 'redux';
import { BrokerRateFilters, BrokerRateModel, BrokerRatesStatisticsModel } from '../../../api/core/core.types';
import { Page } from '../../../api/api.types';

export const GET_BROKER_RATES_LIST = 'GET_BROKER_RATES_LIST';
export const GET_ALL_BROKER_RATES = 'GET_ALL_BROKER_RATES';
export const GET_BROKER_RATES_STATISTICS = 'GET_BROKER_RATES_STATISTICS';
export const GET_BROKER_RATE = 'GET_BROKER_RATE';
export const POST_BROKER_RATE = 'POST_BROKER_RATE';
export const PUT_BROKER_RATE = 'PUT_BROKER_RATE';
export const DELETE_BROKER_RATE = 'DELETE_BROKER_RATE';
export const UPDATE_BROKER_RATE_FILTERS = 'UPDATE_BROKER_RATE_FILTERS';

export interface BrokerRateState {
  brokerRates: BrokerRateModel[] | [];
  selectedBrokerRate: BrokerRateModel | null;
  brokerRatesStatistics: BrokerRatesStatisticsModel[] | [];
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
  filters: BrokerRateFilters | null;
}

export interface GetBrokerRateListAction extends Action {
  type: typeof GET_BROKER_RATES_LIST;
  payload: {
    page: Page<BrokerRateModel>;
  };
}

export interface GetBrokerRatesStatisticsAction extends Action {
  type: typeof GET_BROKER_RATES_STATISTICS;
  payload: {
    brokerRatesStatistics: BrokerRatesStatisticsModel[];
  };
}

export interface GetBrokerRateAction extends Action {
  type: typeof GET_BROKER_RATE;
  payload: {
    selectedBrokerRate: BrokerRateModel | null;
  };
}

export interface GetAllBrokerRatesAction extends Action {
  type: typeof GET_ALL_BROKER_RATES;
  payload: {
    brokerRates: BrokerRateModel[] | []
  };
}

export interface PostBrokerRateAction extends Action {
  type: typeof POST_BROKER_RATE;
  payload: {
    success: boolean;
    newBrokerRate: BrokerRateModel | null;
  };
}

export interface PutBrokerRateAction extends Action {
  type: typeof PUT_BROKER_RATE;
  payload: {
    selectedBrokerRate: BrokerRateModel;
  };
}

export interface DeleteBrokerRateAction extends Action {
  type: typeof DELETE_BROKER_RATE;
  payload: {
    success: boolean;
  };
}

export interface UpdateBrokerRateFilters extends Action {
  type: typeof UPDATE_BROKER_RATE_FILTERS;
  payload: {
    filters: BrokerRateFilters;
  };
}

export type BrokerRateActionTypes =
  GetBrokerRateListAction
  | GetBrokerRateAction
  | PostBrokerRateAction
  | DeleteBrokerRateAction
  | PutBrokerRateAction
  | UpdateBrokerRateFilters
  | GetBrokerRatesStatisticsAction
  | GetAllBrokerRatesAction;
